export const GET_ACTIVITY_PENDING = 'GET_ACTIVITY_PENDING'
export const GET_ACTIVITY_SUCCESSFUL = 'GET_ACTIVITY_SUCCESSFUL'
export const GET_ACTIVITY_ERROR = 'GET_ACTIVITY_ERROR'
